/**
 * Created by soundview on 6/3/15.
 */
var View = require('views/base/view');
var template = require('./templates/view');
var Model = require('../model');
var ClientEditView = View.extend({
	tagName: 'div',
	autoRender: false,
	className: 'modal md-dialog fade',
	template: template,
	id: 'clientEditDialog',
	events: {
		'click .save-btn': 'save',
		'click .close-btn': 'close'
	},
	initialize: function (options) {

		_.bindAll(this, 'render', 'afterRender');
		var _this = this;
		this.render = _.wrap(this.render, function (render) {
			render();
			_this.afterRender();
			return _this;
		});


		this.model = options.model;

		this.model.fetch();

		console.log(this.model);

		this.listenTo(this.model, 'change', this.render);




		this.options = _.defaults(options || {}, this.options);
		//this.template = this.options.template;


		//this.itemView = this.options.itemView;

		ClientEditView.__super__.initialize.call(this, options);


	},
	close: function () {
		this.trigger('onClose', this.model, this);

		if (typeof this.onClose === "function") {
			this.onClose();
		}
		this.dismiss();

	},
	show: function () {
		this.$el.modal('show');
	},
	dismiss: function () {
		this.$el.modal('hide');
	},
	save: function() {
		var data = this.form.getValue();
		this.model.save(data, {
			wait: true,
			patch: true,
			validate: false,
			success: _.bind(function () {
				console.log('success');
				this.close();

			}, this)
		});
	},
	render: function() {

		//var data = {model: this.model.toJSON()};
		//data.installAddons = options.installAddons;

		ClientEditView.__super__.render.apply(this, arguments);

		this.$el.html(this.template());

		this.form = new Backbone.Form({
			model: this.model,
			template: require('./templates/form')
		}).render();


		this.$el.find('#clientEditForm').append(this.form.el);
	},
	afterRender: function () {
		var _this = this;
		//this.stickit();
		this.$el.on('hidden.bs.modal', function (e) {
			// do something...
			console.log('hidden modal');
			_this.dispose();
		});
	}
});

module.exports = ClientEditView;